import React, { useEffect, useState } from "react";
import "./ProductSpecification.css";

import { useDispatch, useSelector } from "react-redux";
import { GoLocation } from "react-icons/go";
import { MdOutlinePanTool } from "react-icons/md";
import { FiHeart } from "react-icons/fi";
import { BsChevronDown } from "react-icons/bs";
import { BsChevronUp } from "react-icons/bs";
import { endpoint } from "api/endpoint";
import { apiHandler } from "api";
import { GrDocumentPdf } from "react-icons/gr";
import { Modal, Button } from "react-bootstrap";
import germfree from "asset/image/germ-free.png";
import ReactTooltip from "react-tooltip";
import COLOR_CODES from "asset/json/colorcodes.json";
import international from "asset/image/Johnson Internantional Double.png";
import newIcon from "asset/image/new_icon.png";
import * as DOMPurify from "dompurify";
import CollapsibleShare from "component/Share/Share";

import {
  StyleheadingButton,
  Roww,
  MainDiv,
  ButtonDiv,
  IconDiv,
  ButtonText,
  DetailDiv,
  DetailText,
  StyledDisplayNonediv,
  StyledDisplayNonedivtwo,
} from "./ProductSpecification.styles";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { setWishlistData } from "features/wishlist/wishlistSlice";
import PropTypes from "prop-types";
import { skusPriceToBeHidden } from "utils/SKUPriceToBeHidden";

const ProductSpecfication = ({
  productname,
  code,
  price,
  productdiscription,
  StyleFeatures,
  productprice,
  isNew,
  productwarranty,
  available_color,
  productId,
  producttechnicaldrawing,
  productimages,
  Breaddata,
  configurable_Options,
  child_products,
  colors_images,
  config_Flag,
  germFreeLogo,
  internationalLogo,
  imageALT,
  iconhigh_tech_cartridges,
  iconchrome_plated,
  icondual_flush,
  iconslim_seat_cover,
  icongerm_free,
  iconsoft_close,
  iconsyphonic_flushing,
  type,
  range,
  size,
  finish,
  color,
  featuredImages,
}) => {
  console.log("config_Flag", config_Flag);
  const dispatch = useDispatch();
  const history = useHistory();
  //  logic of dropdown warranty here
  const [openWaranty, setOpenWaranty] = React.useState(false);
  const [openTechnical, setOpenTechnical] = React.useState(false);
  const { userData, authData } = useSelector((state) => state.login);
  const { wishlistData } = useSelector((state) => state.wishlist);
  const [counter, setCounter] = useState(1);
  const [show, setShow] = useState(false);
  const [logoFlagGermFree, setLogoFlagGermFree] = useState(true);
  const [newProductName, setNewProductName] = useState("");
  const [indeximg, setIndeximg] = useState("0");
  const [colorTipName, setColorTipName] = useState({});

  // Color changes Photos
  const [skuCode, setSkuCode] = useState("");
  const [colorsCodes, setColorsCodes] = useState([]);
  const [selectedColorCode, setSelectedColorCode] = useState({});
  const [hexaCodeColor, setHexaCodeColor] = useState({});
  const [skuMobileView, setSkuMobileView] = useState(false);

  const handleColorCode = (item) => {
    setSelectedColorCode(item);
    colors_images(item);
  };
  useEffect(() => {
    if (window.innerWidth <= 480) {
      setSkuMobileView(true);
    } else {
      setSkuMobileView(false);
    }
  }, []);
  useEffect(() => {
    handlecolorNameProps(color);
  }, [color]);
  // console.log('hexaCodeColor', hexaCodeColor);
  const handlecolorNameProps = (color_Code) => {
    // console.log('FUNCTION_CALLLED');
    if (color_Code) {
      let Obj = {};

      COLOR_CODES &&
        COLOR_CODES.forEach((codes) => {
          if (codes.code === color_Code) {
            Obj = codes;
          }
        });
      setHexaCodeColor(Obj);
      // console.log('**************code', Obj);
    }
  };
  // useEffect(() => {
  // 	getRenderProduct();
  // }, [colorsCodes]);
  // const getRenderProduct = () => {
  // 	const product =
  // 		colorsCodes && colorsCodes.filter((item) => item.sku === skuCode);
  // 	setRenderProduct(product);
  // 	product.forEach((item) => {
  // 		setNewProductName(item.name);
  // 		setNewSku(item.sku);
  // 		setNewPrice(item.price);
  // 		setNewDescription(item.short_description);
  // 	});
  // };
  //ends Here
  const handleClose = async () => {
    setError(false);
    setShow(false);
    setFormData({
      enquire_for: "Products",
      name: "",
      email: "",
      contact_number: "",
      message: "",
      quantity: "",
      comment: "",
      product_sku: "",
      product_name: "",
    });
  };

  const handlecolorName = (color_Code) => {
    if (color_Code) {
      let Obj = {};

      COLOR_CODES &&
        COLOR_CODES.forEach((codes) => {
          if (codes.code === color_Code) {
            Obj = codes;
          }
        });
      setColorTipName(Obj);
      // console.log('**************code', Obj);
    } else {
      setColorTipName("");
    }
  };
  const handleShow = () => setShow(true);
  //increase counter
  const increase = () => {
    setCounter((count) => count + 1);
  };
  useEffect(() => {
    getColorCodes();
  }, [configurable_Options, child_products]);
  const getColorCodes = () => {
    let colorData = [];
    configurable_Options &&
      configurable_Options[Object.keys(configurable_Options)[0]] &&
      configurable_Options[Object.keys(configurable_Options)[0]].forEach(
        (item) => {
          let obj = { sku: item.sku, color_Code: item.default_title };
          const childList =
            child_products &&
            child_products.filter((cp) => cp.sku === item.sku);
          if (childList.length > 0) {
            obj = { ...obj, ...childList[0] };
          }
          colorData.push(obj);
          // console.log('OBEJECT_Each _Color', item);
        }
      );
    setColorsCodes(colorData);
    if (colorData.length > 0) {
      setSelectedColorCode(colorData[0]);
      colors_images(colorData[0]);
    }
  };
  // console.log('.........ARUN_Color', colorsCodes, skuCode);
  // useEffect(() => {
  // 	const objectLength = Object.keys(Breaddata).length;
  // 	console.log('.....Lenght', objectLength);
  // 	console.log('ARAAAAAAAAAAAAAAAAAAaa', Object.values(Breaddata));
  // 	const catgoryName = Object.values(Breaddata).slice(-2, -1)[0];
  // 	console.log('CatgoryName', catgoryName);
  // 	const subCatgoryName = Object.values(Breaddata).slice(-1)[0];
  // 	console.log('SubCatgoryName', subCatgoryName);
  // 	funBreadData(catgoryName, subCatgoryName);

  // 	// if(Breaddata){
  // 	// 	Object.values(Breaddata).forEach(map)
  // 	// }
  // 	// Object.keys(Breaddata);
  // 	// Breaddata[Object.keys(Breaddata)[Object.keys(Breaddata).length - 1]];

  // 	// if (Breaddata && Breaddata[Object.values[objectLength - 1]]) {
  // 	// 	setCatgoryName(Breaddata[Object.values[objectLength - 1]]);
  // 	// }
  // }, [Breaddata]);
  // console.log('...aaaaaaaaaaaaaaaaaaaaaaaaaaaa', catgoryName);
  //decrease counter
  const decrease = () => {
    setCounter((count) => count - 1);
  };
  const [formData, setFormData] = useState({
    enquire_for: "Products",
    name: "",
    email: "",
    contact_number: "",
    city: "",
    state: "",
    quantity: "",
    comment: "",
    product_sku: "",
    product_name: "",
  });
  // console.log('......FORMDATA', formData);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const isValidName = (name) => {
    var regexName = /^[A-Za-z\s]+$/;
    if (typeof name != "undefined" && name.trim() == "") {
      return { message: "This is a required field." };
    }
    if (!regexName.test(name)) {
      return { message: "Name should only contain alphabetical letters." };
    }
    return null;
  };

  const isValidEmail = (email) => {
    var emailCheck = /[!#$%^&*()_+\-=[\]{};':"\\|<>/?]+/;
    if (email.trim() == "") {
      return { message: "This is a required field." };
    }
    if (emailCheck.test(email.trim())) {
      return {
        message:
          "Email should not contain special characters other than . and @.",
      };
    }
    return null;
  };
  const isValidNumber = (contact) => {
    var numCheck = /^[0-9]+$/;
    if (typeof contact != "undefined" && contact.trim() == "") {
      return { message: "This is a required Field." };
    }
    if (!numCheck.test(contact && contact.trim())) {
      return { message: "Number should only contain numeric values." };
    }
    if (contact.length < 10 || contact.length > 10) {
      return { message: "Number should only have 10 digits." };
    }
    return null;
  };

  const isValidCity = (city) => {
    var regexName = /^[A-Za-z\s]+$/;
    if (typeof city != "undefined" && city.trim() == "") {
      return { message: "This is a required field." };
    }
    if (!regexName.test(city)) {
      return { message: "City should only contain alphabetical letters." };
    }
    return null;
  };

  const isValidState = (state) => {
    var regexName = /^[A-Za-z\s]+$/;
    if (typeof state != "undefined" && state.trim() == "") {
      return { message: "This is a required field." };
    }
    if (!regexName.test(state)) {
      return { message: "State should only contain alphabetical letters." };
    }
    return null;
  };

  const isValidQuantity = (quantity) => {
    const regex = /^[0-9]+$/;

    if (typeof quantity === "undefined" || quantity.trim() === "") {
      return { message: "Quantity is a required field." };
    }

    if (!regex.test(quantity)) {
      return { message: "Quantity must contain only numeric characters." };
    }

    const numericValue = parseInt(quantity, 10);

    if (numericValue <= 0) {
      return { message: "Quantity must be a positive number." };
    }
    return null;
  };

  const isValidComment = (comment) => {
    const regex = /^[\w\-!@()+=.,;:/{}|` ]+$/;

    if (typeof comment != "undefined" && comment.trim() == "") {
      return { message: "This is a required Field." };
    }
    if (!regex.test(comment)) {
      return { message: "Special characters are not allowed" };
    }
    return null;
  };

  const validate = () => {
    const { name, email, contact_number, city, state, quantity, comment } =
      formData;
    if (
      isValidName(name) != null ||
      isValidEmail(email) != null ||
      isValidNumber(contact_number) != null ||
      isValidCity(city) != null ||
      isValidState(state) != null ||
      isValidQuantity(quantity) != null ||
      isValidComment(comment) != null
    ) {
      setError(true);
      return false;
    } else {
      setError(false);
      return true;
    }
  };

  // const handleFormSubmit = () => {
  // 	if (!validate()) {
  // 		return;
  // 	}
  // 	// } else {
  // 	// 	handlesumbit();
  // 	// }
  // 	console.log(formData);
  // };
  const handlesumbit = async () => {
    if (!validate()) {
      return;
    }
    let productData = {
      parameters: {
        customer_name: formData.name,
        contact_number: formData.contact_number,
        customer_email: formData.email,
        city: formData.city,
        state: formData.state,
        product_name: productname,
        product_sku: code,
        comment: formData.comment,
        quantity: formData.quantity,
      },
    };
    const result = await apiHandler({
      url: `${endpoint.RQEQUEST_FOR_PRICE}`,
      method: "POST",
      data: productData,
    });
    // console.log('*********data', result.data);
    if (result.data.status === "true") {
      handleClose();
      setFormData({
        enquire_for: "Products",
        name: "",
        email: "",
        contact_number: "",
        city: "",
        state: "",
        quantity: "",
        comment: "",
        product_sku: "",
        product_name: "",
      });
      // history.push("/thank-you");
      window.location.href = "/thank-you";
    }
  };
  // console.log(
  // 	'.....datadatadatadatadat',
  // 	formData.name,
  // 	formData.contact_number,
  // 	formData.email,
  // 	formData.message,
  // 	productname,
  // 	code,
  // 	formData.comment
  // );
  const addProductToWishlist = async () => {
    // if (!authData.authToken) {
    // 	toast.info('Please Log in or Register to add product to wishlist.');
    // 	// alert('Please Log in or Register to add product to wishlist.');
    // 	// console.log(history)

    // 	history.push({
    // 		pathname: '/login',
    // 		state: { fromScreen: 'product_specification' },
    // 	});
    // 	return;
    // }
    const prod = {
      productname: config_Flag ? selectedColorCode.name : productname,
      code: config_Flag ? selectedColorCode.sku : code,
      productdiscription: config_Flag
        ? selectedColorCode.short_description
        : productdiscription,
      // StyleFeatures,
      productprice: config_Flag ? "" : productprice,
      // productwarranty,
      // available_color,
      productId: config_Flag ? selectedColorCode.id : productId,
      // producttechnicaldrawing,
      productimages: config_Flag ? selectedColorCode.images : productimages,
      counter,
    };
    dispatch(setWishlistData(prod));
    const findArrayElementByTitle = (title) => {
      const arraynew = [];
      const result = wishlistData.filter((item) => item.productId > productId);
      // console.log('......reduxwishlist updated', result);
    };

    // console.log('......reduxwishlist updated', wishlistData);
    // const result = await apiHandler({
    // 	url: `${endpoint.WISHLIST}/add/${productId}?customer_id=${userData.id}`,
    // 	method: 'POST',
    // });
    // console.log('PRODUCT DETAILS - wishlist', productId, result.data);
    // if (result.data) {
    toast.success("Product added Successfully to the wishlist.");
    // }
    // dispatch(addToWishlist(result.data));
  };
  useEffect(() => {
    if (counter < 1) {
      setCounter(1);
    }
  }, [counter]);
  return (
    <>
      <div className="main-heading detailpageHeading text-left">
        <h1 className="productHeading">
          {config_Flag ? selectedColorCode.name : productname}
          {/* &nbsp;{" "}
          {isNew ? (
            <span>
              <img
                src={newIcon}
                className="newLogoDetailPage"
                alt="germ-free"
                width={1500}
                height={1200}
                loading="lazy"
              />
            </span>
          ) : null} */}
        </h1>{" "}
        <div>
          <CollapsibleShare />
        </div>
      </div>
      <span className="product-detail-germfree-detail ">
        {germFreeLogo === "GF" && (
          <span>
            <img
              src={germfree}
              alt="germ-free"
              width={2006}
              height={1858}
              loading="lazy"
            />
          </span>
        )}
        {internationalLogo === "JI" && (
          <span>
            <img
              src={international}
              alt="germ-free"
              width={2884}
              height={1368}
              loading="lazy"
            />
          </span>
        )}
      </span>

      <div className="price-box">
        {config_Flag && (
          <ul className="availablecolor">
            <div className="colorflex">
              <li>
                <h3>Available Color </h3>
              </li>

              {colorsCodes &&
                colorsCodes.map((item, i) => (
                  <>
                    {/* {Object.values(item) &&
										Object.values(item).map((code) => ( */}
                    <>
                      <div
                        key={i}
                        className="paddingclr"
                        onClick={(e) => handleColorCode(item)}
                      >
                        <div
                          onMouseEnter={(e) => handlecolorName(item.color_Code)}
                          className="colorborderspec"
                        >
                          <a
                            data-for="ColorCode"
                            data-tip={"No Color Name "}
                            data-iscapture="true"
                          >
                            <StyleheadingButton color={item.color_Code} />
                          </a>
                          <ReactTooltip
                            id="ColorCode"
                            overridePosition={(
                              { left, top },
                              currentEvent,
                              currentTarget,
                              node
                            ) => {
                              const d = document.documentElement;
                              left = Math.min(
                                d.clientWidth - node.clientWidth,
                                left
                              );
                              top = Math.min(
                                d.clientHeight - node.clientHeight,
                                top
                              );
                              left = Math.max(0, left);
                              top = Math.max(0, top);
                              return { top, left };
                            }}
                          >
                            {colorTipName && colorTipName.Colour}
                          </ReactTooltip>
                        </div>
                      </div>
                    </>
                    {/* ))} */}
                  </>
                ))}
            </div>
          </ul>
        )}

        {/* <div className='paddingclr'>
							<div className='colorborderspec'>
								<StyleheadingButton color={'#fff'} />
							</div>
						</div> */}
        {/* {configurable_Options &&
					configurable_Options[Object.keys(configurable_Options)[0]] &&
					configurable_Options[Object.keys(configurable_Options)[0]].map(
						(code, j) => (
							<>
								<ul className='availablecolor'>
									<div className='colorflex'>
										<li>
											<h3>Available Color </h3>
										</li>

										<div key={j} className='paddingclr'>
											<div className='colorborderspec'>
												<StyleheadingButton color={code.default_title} />
											</div>
										</div>
									</div>
								</ul>
							</>
						)
					)} */}
      </div>
      {!config_Flag && (
        <div className="price-box">
          {available_color && available_color !== "NA" && (
            <ul className="availablecolor sku_code_detail">
              <div className="colorflex">
                <li>
                  <h3>Available Color </h3>
                </li>

                {available_color.split(",").map((color, i) => (
                  <div key={i} className="paddingclr">
                    <div
                      onMouseEnter={(e) => handlecolorName(color)}
                      className="colorborderspec"
                    >
                      <a
                        data-for="ColorCode"
                        data-tip={"No Color Name "}
                        data-iscapture="true"
                      >
                        <StyleheadingButton color={color} />
                      </a>
                      <ReactTooltip
                        id="ColorCode"
                        overridePosition={(
                          { left, top },
                          currentEvent,
                          currentTarget,
                          node
                        ) => {
                          const d = document.documentElement;
                          left = Math.min(
                            d.clientWidth - node.clientWidth,
                            left
                          );
                          top = Math.min(
                            d.clientHeight - node.clientHeight,
                            top
                          );
                          left = Math.max(0, left);
                          top = Math.max(0, top);
                          return { top, left };
                        }}
                      >
                        {colorTipName && colorTipName.Colour}
                      </ReactTooltip>
                    </div>
                  </div>
                ))}
              </div>
            </ul>
          )}
          {available_color && available_color === "NA" && (
            <ul className="availablecolor sku_code_detail">
              <div className="colorflex">
                <li>
                  <h3>Available Color : NA</h3>
                </li>{" "}
              </div>
            </ul>
          )}
        </div>
      )}
      {/* // <!-- End .price-box --> */}
      {skuMobileView === false && (
        <ul className="price_element">
          <li className="">
            {/* Code :<strong>{code}</strong> */}
            CODE :<strong>{config_Flag ? selectedColorCode.sku : code}</strong>
          </li>
        </ul>
      )}
      {skuMobileView === true &&
        !(config_Flag ? selectedColorCode.sku : code).includes(",") && (
          <ul className="price_element">
            <li className="">
              {/* Code :<strong>{code}</strong> */}
              CODE :
              <strong>{config_Flag ? selectedColorCode.sku : code}</strong>
            </li>
            <br />
          </ul>
        )}
      {skuMobileView === true &&
        (config_Flag ? selectedColorCode.sku : code).includes(",") && (
          <>
            <>
              <span className="sku-code-font">CODE :-</span>
              {(config_Flag ? selectedColorCode.sku : code)
                .split(",")
                .map((sku, i) => (
                  <>
                    {/* Code :<strong>{code}</strong> */}
                    <span className="sku-code-font" key={i}>
                      <strong>
                        {sku}
                        {(config_Flag ? selectedColorCode.sku : code).split(",")
                          .length !==
                          i + 1 && " ,"}
                      </strong>
                    </span>
                  </>
                ))}
            </>
            <br />
            <br />
          </>
        )}
      {/* 
      {(
        config_Flag
          ? skusPriceToBeHidden.includes(selectedColorCode.sku)
          : skusPriceToBeHidden.includes(code)
      ) ? null : (
        <ul className="single-info-list">
          <li>
            PRICE :&nbsp;
            <strong>
            ₹{config_Flag
                ? parseFloat(selectedColorCode.price).toFixed(2)
                : parseFloat(price).toFixed(2)}
            </strong>
          </li>
        </ul>
      )} */}

      <div className="divider mb-0 mt-0">
        {/* <!-- End .product-desc --> */}

        {(StyleFeatures !== "" || type) && (
          <>
            <h3>Specifications/Features</h3>
          </>
        )}

        {StyleFeatures !== "" && (
          <>
            <div className="product-feature pt-4">
              <div
                className="product-desc-content"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(StyleFeatures),
                }}
              />
            </div>
          </>
        )}
        <div className="row">
          {type && (
            <div className="col-6 pt-3 ">
              <b className="specfic-detail">Type :</b> {type}
            </div>
          )}
          {range && (
            <div className="col-6 pt-3 ">
              <b className="specfic-detail">Range :</b>
              {range}
            </div>
          )}
          {size && (
            <div className="col-6 pt-3 ">
              <b className="specfic-detail">Size : </b>
              {size}
            </div>
          )}
          {finish && (
            <div className="col-6 pt-3 ">
              <b className="specfic-detail">Finish :</b>
              {finish}
            </div>
          )}
          {color && (
            <div className="col-6 pt-3 ">
              <b className="specfic-detail">Colour : </b>
              {(hexaCodeColor && hexaCodeColor.Colour) || "NA"}
            </div>
          )}
          {/* {germFreeLogo && (
						<div className='col-6 p-4'>
							<b className='specfic-detail'>GermFree : </b>
							{germFreeLogo}
						</div>
					)}
					{internationalLogo && (
						<div className='col-6 p-4'>
							<b className='specfic-detail'>Internantional :</b>{' '}
							{internationalLogo}
						</div>
					)} */}
        </div>
        <div className="icons-main-div">
          {featuredImages && featuredImages.length
            ? featuredImages
                .filter((item) => item.key !== "product_banner")
                .map((imageDetails, i) => (
                  <div className="icons-list-div" key={imageDetails.key}>
                    <center>
                      {" "}
                      <img
                        className=""
                        src={imageDetails.path}
                        width={92}
                        height={94}
                        loading="lazy"
                      />
                    </center>
                    <center>{imageDetails.label}</center>
                  </div>
                ))
            : null}
          {/* {iconchrome_plated &&
            iconchrome_plated !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <center>
                  {" "}
                  <img
                    className=""
                    src={iconchrome_plated}
                    width={92}
                    height={94}
                    loading="lazy"
                  />
                </center>
                <center>Chrome Plated</center>
              </div>
            )} */}

          {/* {icondual_flush &&
            icondual_flush !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <center>
                  <img
                    className=""
                    src={icondual_flush}
                    width={92}
                    height={94}
                    loading="lazy"
                  />
                </center>
                <center>Dual Flush</center>
              </div>
            )} */}
          {/* {icongerm_free &&
            icongerm_free !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <center>
                  <img
                    className=""
                    src={icongerm_free}
                    width={92}
                    height={94}
                    loading="lazy"
                  />
                </center>{" "}
                <center>Germ Free</center>
              </div>
            )} */}

          {/* {iconhigh_tech_cartridges &&
            iconhigh_tech_cartridges !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <img
                  className=""
                  src={iconhigh_tech_cartridges}
                  width={92}
                  height={94}
                  loading="lazy"
                />
                <center>High Tech Cartridges</center>
              </div>
            )} */}

          {/* {iconsoft_close &&
            iconsoft_close !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <center>
                  {" "}
                  <img
                    className=""
                    src={iconsoft_close}
                    width={92}
                    height={94}
                    loading="lazy"
                  />
                </center>
                <center>Soft Close</center>
              </div>
            )} */}
          {/* {iconsyphonic_flushing &&
            iconsyphonic_flushing !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <center>
                  <img
                    className=""
                    src={iconsyphonic_flushing}
                    width={92}
                    height={94}
                    loading="lazy"
                  />
                </center>
                <center>Syphonic Flushing</center>
              </div>
            )} */}

          {/* {iconslim_seat_cover &&
            iconslim_seat_cover !==
              "https://backend.johnsonbathrooms.in/media/catalog/productno_selection" && (
              <div className="icons-list-div">
                <center>
                  <img
                    className=""
                    src={iconslim_seat_cover}
                    width={92}
                    height={94}
                    loading="lazy"
                  />
                </center>
                <center>Uf Slim Seat Cover</center>
              </div>
            )} */}
        </div>
        <StyledDisplayNonedivtwo>
          <div
            className="product-desc"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(productdiscription),
            }}
          />
        </StyledDisplayNonedivtwo>
        <StyledDisplayNonediv>
          {/* <div className='product-desc'> */}
          <div
            className="product-desc"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(productdiscription),
            }}
          />
          {/* <p>{productdiscription}</p> */}
          {/* </div> */}
        </StyledDisplayNonediv>

        {productwarranty != "" ? (
          <div className="product-desc" style={{ borderTop: "none" }}>
            <p>
              <strong>Product Waranty</strong>
            </p>
            <p>{productwarranty}</p>
          </div>
        ) : null}

        <div className="product-action">
          {/* <span className='float-none'>
						<strong>Choose State to get the Price</strong>
					</span> */}

          {/* <div className='row pt-4'> */}
          {/* <div className='col-8 state-choose'>
							<span className='pt-4 float-none'>
								<strong>State</strong>
							</span>
							<select name='cars' id='cars'>
								<option value='delhi'>Delhi & NCR</option>
								<option value='hp'>Himachal Pradesh</option>
								<option value='up'>Uttar Pradesh</option>
								<option value='punjab'>Punjab</option>
							</select>
						</div> */}
          {/* <div className='col-4'>
							<span className='float-none pt-4'>
								<strong>Quantity</strong>
							</span>
							<div className='flex-detail product-single-qty'>
								<button className='btn-detail' onClick={(e) => decrease(e)}>
									{' '}
									-
								</button>
								<input
									className='horizontal-quantity form-control'
									type='text'
									value={counter}
									onChange={(e) => setQuantity(e.target.value)}
								/>
								<button className='btn-detail' onClick={(e) => increase(e)}>
									{' '}
									+{' '}
								</button>
							</div>
						</div> */}
          {/* <div className='col-md-4'>
							<h3 className='pt-4'>Quantity</h3>
							<div className='product-single-qty'>
								<input
									className='horizontal-quantity form-control'
									type='text'
								/>
							</div>
						</div> */}
          {/* <div className='col-md-12 pt-3'>
							<span className='float-none'>
								<strong> MRP:</strong>
							</span>
							<span className='product-price'>&#8377; {productprice}</span>
						</div> */}
          {/* </div> */}
          {/* <!-- End .product-single-qty --> */}
        </div>
        {/* <!-- End .product-action --> */}

        <div className="product-action">
          {/* < />!-- End .product-single-qty --> */}
          <div onClick={(e) => handleShow(e)} className="button-box">
            <MdOutlinePanTool className="fa fa-info-circle" /> Request for Price
          </div>
          <span>
            <Link to="/locate/dealer">
              <div className="button-box">
                <GoLocation className="fa fa-map-marker-alt" /> Where to Buy
              </div>
            </Link>
          </span>
          {/* <Link to={'/locate/corporate-office'}> */}

          {/* </Link> */}
          <div>
            <Modal className="requestforprice" show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Request for Price</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* <div className='col-md-12 '> */}
                {/* <h2 className='mb-2'>Send Us a Message</h2> */}

                {/* <form onSubmit={handleFormSubmit}> */}
                {/* <label className='mb-0' htmlFor='contact-name'>
									Enquiry For <span className='required'>*</span>
								</label> */}
                <div className="row">
                  <div className="col-md-6 ">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Enter Name"
                        value={formData.name}
                        onChange={(e) => handleChange(e)}
                        required=""
                      />
                      <span className="error_message">
                        {error && isValidName(formData.name)
                          ? isValidName(formData.name).message
                          : ""}
                      </span>
                    </div>
                  </div>
                  {/* </div> */}
                  <div className="col-md-6 ">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        type="eamil"
                        name="email"
                        className="form-control"
                        placeholder="Enter Email"
                        value={formData.email}
                        onChange={(e) => handleChange(e)}
                      />
                      <span className="error_message">
                        {error && isValidEmail(formData.email)
                          ? isValidEmail(formData.email).message
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        Contact No <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="contact_number"
                        placeholder="Enter 10 digit contact number"
                        className="form-control"
                        required=""
                        value={formData.contact_number}
                        onChange={(e) => handleChange(e)}
                      />
                      <span className="error_message">
                        {error && isValidNumber(formData.contact_number)
                          ? isValidNumber(formData.contact_number).message
                          : ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        Product name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="product_name"
                        placeholder="your SKU code"
                        className="form-control"
                        required=""
                        disabled
                        value={
                          config_Flag ? selectedColorCode.name : productname
                        }
                        onChange={(e) => handleChange(e)}
                      />
                      {/* <span className='error_message'>
										{error && formData.product_name === ''
											? 'This is a required field.'
											: ''}
										</span> */}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        SKU <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="product_sku"
                        placeholder="your SKU code"
                        className="form-control"
                        required=""
                        disabled
                        value={config_Flag ? selectedColorCode.sku : code}
                        onChange={(e) => handleChange(e)}
                      />
                      {/* <span className='error_message'>
										{error && formData.product_sku === ''
											? 'This is a required field.'
											: ''}
										</span> */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        Quantity <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        name="quantity"
                        placeholder="Enter quantity to be requested"
                        className="form-control"
                        required=""
                        value={formData.quantity}
                        onChange={(e) => handleChange(e)}
                      />
                      <span className="error_message">
                        {error && isValidQuantity(formData.quantity)
                          ? isValidQuantity(formData.quantity).message
                          : ""}
                      </span>

                      {/* <div className='form-group'>
									<label className='mb-0' htmlFor='contact-email'>
										Location/City <span className='required'>*</span>
									</label>
									<input
										type='text'
										name='city'
										placeholder='Enter City'
										className='form-control'
										required=''
										value={formData.city}
										onChange={(e) => handleChange(e)}
									/>
									<span className='error_message'>
										{error && isValidName(formData.city)
											? isValidName(formData.city).message
											: ''}
									</span>
								</div> */}

                      {/* <div className='form-group'>
									<label className='mb-0' htmlFor='contact-message'>
										Message <span className='required'>*</span>
									</label>
									<textarea
										cols='10'
										rows='1'
										className='form-control'
										required=''
										name='message'
										value={formData.message}
										onChange={(e) => handleChange(e)}
									></textarea>
									<span className='error_message'>
										{error && formData.message === ''
											? 'This is a required field.'
											: ''}
									</span>
								</div> */}

                      {/* <div className='form-footer mb-0'>
									<button
										type='submit'
										className='btn btn-dark font-weight-normal'
										onClick={handleFormSubmit}
									>
										Submit
									</button>
								</div> */}
                      {/* </form> */}
                    </div>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        City <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="city"
                        placeholder="Enter City"
                        className="form-control"
                        required=""
                        value={formData.city}
                        onChange={(e) => handleChange(e)}
                      />
                      <span className="error_message">
                        {error && isValidCity(formData.city)
                          ? isValidCity(formData.city).message
                          : ""}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {" "}
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        State <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="state"
                        placeholder="Enter State"
                        className="form-control"
                        required=""
                        value={formData.state}
                        onChange={(e) => handleChange(e)}
                      />
                      <span className="error_message">
                        {error && isValidState(formData.state)
                          ? isValidState(formData.state).message
                          : ""}
                      </span>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <label className="mb-0" htmlFor="contact-email">
                        Comment <span className="required">*</span>
                      </label>
                      <textarea
                        rows="2"
                        cols="25"
                        type="text"
                        name="comment"
                        placeholder="Leave your comment"
                        className="form-control"
                        required=""
                        value={formData.comment}
                        onChange={(e) => handleChange(e)}
                      />
                      <span className="error_message">
                        {error && isValidComment(formData.comment)
                          ? isValidComment(formData.comment).message
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>
                <Button
                  onClick={(e) => {
                    // handleFormSubmit(e);
                    handlesumbit(e);
                    // handleClose(e);
                  }}
                  variant="primary"
                  // onClick={handleClose}
                >
                  Make Request
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <a>
            <div
              className="button-box margintopwish"
              onClick={() => {
                addProductToWishlist();
              }}
            >
              <FiHeart className="fa fa-heart" /> Add to Wishlist
            </div>
          </a>
        </div>
        {/* <!-- End .product-action --> */}

        <div className="divider mb-0 mt-0">
          <div className="product-single-collapse" id="productAccordion">
            {/* {productwarranty != "" && (
              <MainDiv className="dropdown">
                {" "}
                <ButtonDiv
                  onClick={() => setOpenWaranty((openWaranty) => !openWaranty)}
                >
                  {" "}
                  <Roww>
                    {" "}
                    <IconDiv>
                      {!openWaranty && <BsChevronDown />}
                      {openWaranty && <BsChevronUp />}{" "}
                    </IconDiv>
                    <ButtonText>Product Waranty</ButtonText>{" "}
                  </Roww>{" "}
                </ButtonDiv>{" "}
                {openWaranty && (
                  <DetailDiv>
                    <DetailText>{productwarranty}</DetailText>
                  </DetailDiv>
                )}
              </MainDiv>
            )} */}
            {producttechnicaldrawing != "" && (
              <MainDiv className="dropdown">
                {" "}
                <ButtonDiv
                  onClick={() =>
                    setOpenTechnical((openTechnical) => !openTechnical)
                  }
                >
                  {" "}
                  <Roww>
                    {" "}
                    <IconDiv>
                      {!openTechnical && <BsChevronDown />}
                      {openTechnical && <BsChevronUp />}{" "}
                    </IconDiv>
                    <ButtonText>Technical Drawings</ButtonText>{" "}
                  </Roww>{" "}
                </ButtonDiv>{" "}
                {openTechnical && (
                  <DetailDiv>
                    <DetailText>{producttechnicaldrawing}</DetailText>
                  </DetailDiv>
                )}
              </MainDiv>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
ProductSpecfication.propTypes = {
  // listofimage: PropTypes.array,
  // three3d: PropTypes.string,
  // flag3dImage: PropTypes.bool.isRequired,
  // // trade: PropTypes.object.isRequired,
  // productname: PropTypes.string,
  // code: PropTypes.string,
  // productdiscription: PropTypes.string,
  // StyleFeatures: PropTypes.string,
  // productprice: PropTypes.string,
  // productwarranty: PropTypes.string,
  // available_color: PropTypes.array,
  // productId: PropTypes.string,
  // producttechnicaldrawing: PropTypes.string,
  // productimages: PropTypes.array,
  // Breaddata: PropTypes.object,
  // configurable_Options: PropTypes.object,
  // child_products: PropTypes.array,
  // colors_images: PropTypes.array,
  // config_Flag: PropTypes.bool,
  // germFreeLogo: PropTypes.bool,
  // internationalLogo: PropTypes.bool,
  // type: PropTypes.string,
  // range: PropTypes.string,
  // size: PropTypes.string,
  // finish: PropTypes.string,
  // color: PropTypes.string,
};
export default ProductSpecfication;
